export default __webpack_public_path__ + "static/media/menu_icon.46f51a83.svg";